import { convertImagePath } from "@tential/ec-gql-schema/utils/img"

export const ConvertImagePath = (src = "", size = 1, width?: number, height?: number) => {
  const config = useRuntimeConfig()
  return convertImagePath(config.public.APP_ENV || process.env.APP_ENV || "development", src, size, width, height)
}
